export default __webpack_public_path__ + "static/media/Crypto Tracker Portfolio Image.2266b487.png";